import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import { msToTime } from 'utils/common';
import { UNIFIED_FEED_DOMAIN_SERVICE, TOI_LIVE_DOMAIN } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import GameOverlay from '../GameOverlay/GameOverlay';
//import LeaderBoard from '../LeaderBoard/LeaderBoard';
// import PracticeCard from '../PracticeCard/PracticeCard';
// import GameCard from '../GameCard/GameCard';
import s from './SudokuGame.scss';
import breadcrumbs from '../../../GameBreadcrumbsHelper';
import BreadCrumb from '../../../../../components_v2/common/BreadCrumb/BreadCrumb';
import ShareButton from '../ShareButton/ShareButton';
import {
  loadSyncUp,
  loadSudokuStateFetch,
  loadSudokuStateSave,
} from '../../../redux';
//import NewGameTimer from '../NewGameTimer/NewGameTimer';
// import Congratulations from '../Congratulations/Congratulations';
import CongratulationsNew from '../CongratulationsNew/CongratulationsNew';
// import GameCardListing from '../GameCardListing/GameCardListing';
import AutoCheck from '../AutoCheck/AutoCheck';
import MoreOnGames from '../MoreOnGames/MoreOnGames';
import {
  fireGa4andGrx,
  timeStringToMilliseconds,
} from '../../../layouts/utils';

const SudokuGame = props => {
  const {
    isMobile,
    puzzleAPI,
    userData,
    todaysGame,
    isToday,
    levelData,
    handleGameCallback,
    apiConfigData,
    buttonClicked,
    gameSolutionData,
    viewSolution,
    showCongratulationsData,
  } = props;
  let { stateData } = props;
  const configPenalty = apiConfigData?.penaltyTimeForCharRevealInSec || 5;
  const configSaveStateCounter = apiConfigData?.saveStateTimerValueInSec || 5;
  const gameType = 'sudoku';
  // const gamesListingData =
  //   props.gameslisting && props.gameslisting ? props.gameslisting : {};
  const gamesMetaWidgetData = props.gamesmetawidget;
  let gameId = puzzleAPI && puzzleAPI.gameId ? puzzleAPI.gameId : '';
  if (levelData && levelData.gameID) {
    gameId = levelData.gameID;
  }

  let jsonUrl = puzzleAPI && puzzleAPI.url ? puzzleAPI.url : '';
  if (levelData && levelData.deeplink) {
    jsonUrl = levelData.deeplink;
  }
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';
  let playAgainCheckTemp = false;
  if (typeof localStorage !== 'undefined') {
    let toigames = localStorage.getItem('toigames');
    toigames = toigames ? JSON.parse(toigames) : {};
    playAgainCheckTemp =
      toigames.playagain && toigames.playagain.includes(gameId);
  }

  const commonTranslations = _get(
    props,
    'gamesconfigData.translations.commonTranslations',
    {},
  );
  const gameSpecificTranslations = _get(
    props,
    'gamesconfigData.translations.gameSpecificTranslations.sudoku',
    {},
  );

  const [playAgainCheck, setPlayAgainCheck] = useState(playAgainCheckTemp);

  const [hasSynced, setHasSynced] = useState(false);
  const [showLoader, setLoader] = useState(true);
  const [puzzle, setPuzzle] = useState([]);
  const [solution, setSolution] = useState([]);
  const [board, setBoard] = useState([]);
  const [initialFilledCells, setInitialFilledCells] = useState([]);
  const [lastFocussedCell, setFocusedCell] = useState({ row: 0, column: 0 });
  const [timer, setTimer] = useState(0);
  const [status, setStatus] = useState('playing');
  const [revealedCells, setRevealedCells] = useState([]);
  const [menuVisible, setMenuVisible] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [showCongrate, setCongrate] = useState(
    showCongratulationsData || false,
  );
  //const [penaltyCount, setPenaltyCount] = useState(0);
  const [totalPenaltyTime, setTotalPenaltyTime] = useState(0);
  const [penaltyMessage, setPenaltyMessage] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [resultData, setResultData] = useState(undefined);
  const [alreadyPlayed, setAlreadyPlayed] = useState(false);
  // const [submitCallPending, setSubmitCallPending] = useState(true);
  const [isPencilMode, setIsPencilMode] = useState(false);
  const [isAllCellFull, setIsAllCellFull] = useState(false);
  const initialPencilBoard = Array(9)
    .fill(0)
    .map(() => Array(9).fill([]));
  const [pencilBoard, setPencilBoard] = useState(initialPencilBoard);
  const [isAutoSuggestActive, setIsAutoSuggestActive] = useState(false);
  const [tooltipText, setTooltipText] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [isShimmering, setIsShimmering] = useState(false);

  const timerRef = useRef(null);
  const isPausedRef = useRef(false);
  //const isSubmittedRef = useRef(false);
  const userDataRef = useRef(userData);
  const penaltySpanRef = useRef(null);
  const boardRef = useRef(board);
  const revealedCellsRef = useRef(revealedCells);
  const totalPenaltyTimeRef = useRef(totalPenaltyTime);
  const pencilBoardRef = useRef(pencilBoard);
  const lastFocussedCellRef = useRef(lastFocussedCell);
  const [failedAPI, setFailedAPI] = useState('');

  const fireGaGameScreen = (gaLabelText, score = '', gaType) => {
    const gaData = {
      event: 'user_shown_games',
      type: gaType || 'gameplay_screen',
      label: gaLabelText,
      page_template: 'gameplay',
      section: 'games',
      subsection: 'sudoku',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (score) {
      gaData.score = score;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const gameSyncCall = () => {
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    const params = {
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  const clearLocalStorage = key => {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  };

  const overlayCall = type => {
    setShowOverlay(true);
    setPopUpType(type);
  };

  const clearPlayAgain = () => {
    if (typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      let playagainArray = toigames.playagain && toigames.playagain.split(',');
      if (playagainArray && playagainArray.includes(gameId)) {
        playagainArray = playagainArray.filter(id => id !== gameId);
        toigames.playagain = playagainArray.join(',');
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
  };

  const gameStateSaveCall = () => {
    if (
      typeof props.loadSudokuStateSave === 'function' &&
      userData &&
      userData.isLoggedIn &&
      todaysGame &&
      !playAgainCheck &&
      Array.isArray(boardRef.current) &&
      boardRef.current.length > 0
    ) {
      try {
        const gridSize = { row: 9, column: 9 };
        const params = {
          gameId,
          gameType,
          grxId,
          ssoId,
          isPencilModeOn: isPencilMode,
          isCandidateModeOn: isAutoSuggestActive,
          gridSize,
          penaltyTimeInMillis: totalPenaltyTimeRef.current * 1000,
          completionTimeInMillis: timerRef.current * 1000,
          penaltyPairs: revealedCellsRef.current,
          board: boardRef.current,
          pencilBoard: pencilBoardRef.current,
          lastFocussedCell: lastFocussedCellRef.current,
        };
        props.loadSudokuStateSave(params);
      } catch (e) {
        console.log('game error>>', e);
      }
    }
  };

  const getGameJsonCall = () => {
    const url = `${jsonUrl}`;
    makeRequest
      .get(url, {}, 'skipfeedengine')
      .then(data => {
        const puzzleData = data?.data?.puzzle;
        const solutionData = data?.data?.solution;
        setPuzzle(puzzleData);
        setSolution(solutionData);
        if (
          !localStorage.getItem(`tilsudoku:${gameId}`) &&
          !(
            stateData &&
            stateData.stateSudoku &&
            stateData.stateSudoku.gameId === gameId
          )
        ) {
          setBoard(puzzleData.map(row => [...row]));
        }
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('puzzle_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
    return false;
  };

  const getStatusCall = () => {
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/status/game?pc=toi&pfm=web&playAgain=false&fv=1325&gameId=${gameId}&gameType=sudoku`;
    const requestParams = {
      params: {},
      headers: {
        grxId,
        ssoId,
      },
    };
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        if (data && data.data && Array.isArray(data.data.items)) {
          if (data && data.data && data.data.hasPlayed && !playAgainCheck) {
            const gameCongratulationsData = data.data.items.filter(
              item => item.tn === 'gameCongratulationsData',
            )[0];
            if (
              gameCongratulationsData &&
              gameCongratulationsData.gameCongratulationsData
            ) {
              const loggedInResult = !!(grxId && ssoId);
              setResultData({
                ...gameCongratulationsData.gameCongratulationsData,
                loggedInResult,
              });
              const achievementCards =
                gameCongratulationsData?.gameCongratulationsData
                  ?.achievementCards;
              const tempGameScore =
                Array.isArray(achievementCards) &&
                achievementCards.length > 0 &&
                typeof achievementCards[0]?.primaryText === 'string' &&
                achievementCards[0].primaryText.trim() !== ''
                  ? timeStringToMilliseconds(achievementCards[0].primaryText)
                  : 'N/A';
              fireGaGameScreen('view_results', tempGameScore, 'results_score');
            }
            setLoader(false);
            setCongrate(true);
            setAlreadyPlayed(true);
            clearLocalStorage(`tilsudoku:${gameId}`);
          } else {
            try {
              if (playAgainCheck) {
                if (data && data.data && data.data.hasPlayed) {
                  const gameCongratulationsData = data.data.items.filter(
                    item => item.tn === 'gameCongratulationsData',
                  )[0];
                  if (
                    gameCongratulationsData &&
                    gameCongratulationsData.gameCongratulationsData
                  ) {
                    const loggedInResult = !!(grxId && ssoId);
                    setResultData({
                      ...gameCongratulationsData.gameCongratulationsData,
                      loggedInResult,
                    });
                  }
                }
              }
              getGameJsonCall();
            } catch (error) {
              console.error('error inside game js >>', error);
            }
            setLoader(false);
            fireGaGameScreen(
              buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
            );
          }
          return false;
        }
        try {
          getGameJsonCall();
        } catch (error) {
          console.error('error inside game js >>', error);
        }
        setLoader(false);
        fireGaGameScreen(
          buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
        );
        return false;
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('status_api');
        overlayCall('errorPopUp');
        setLoader(false);
        fireGaGameScreen(
          buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
        );
      });
    return false;
  };

  const gameSubmitCall = (timeTaken, timePenalty) => {
    const tempPlayAgainCheck = playAgainCheck ? '&playAgain=true' : '';
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/submit/game?pc=toi&pfm=web&fv=1291&gameId=${gameId}&gameType=sudoku${tempPlayAgainCheck}`;
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    // Get the current game state parameters
    const gridSize = { row: 9, column: 9 };
    const postData = {
      penaltyTimeInMillis: timePenalty * 1000,
      completionTimeInMillis: (timeTaken + timePenalty) * 1000,
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      penaltyItem: {
        hints: 0,
        emptyCells: 0,
        wrongInput: 0,
      },
      // Add game state parameters
      isPencilModeOn: isPencilMode,
      isCandidateModeOn: isAutoSuggestActive,
      gridSize,
      penaltyPairs: revealedCellsRef.current,
      board: boardRef.current,
      pencilBoard: pencilBoardRef.current,
      lastFocussedCell: lastFocussedCellRef.current,
    };

    setLoader(true);
    makeRequest
      .post(url, postData, { headers: { grxId, ssoId } })
      .then(data => {
        if (data && data.data && Array.isArray(data.data.items)) {
          setPlayAgainCheck(false);
          const gameCongratulationsData = data.data.items.filter(
            item => item.tn === 'gameCongratulationsData',
          )[0];
          if (
            gameCongratulationsData &&
            gameCongratulationsData.gameCongratulationsData
          ) {
            const loggedInResult = !!(grxId && ssoId);
            setResultData({
              ...gameCongratulationsData.gameCongratulationsData,
              loggedInResult,
            });
            const achievementCards =
              gameCongratulationsData?.gameCongratulationsData
                ?.achievementCards;
            const tempGameScore =
              Array.isArray(achievementCards) &&
              achievementCards.length > 0 &&
              typeof achievementCards[0]?.primaryText === 'string' &&
              achievementCards[0].primaryText.trim() !== ''
                ? timeStringToMilliseconds(achievementCards[0].primaryText)
                : 'N/A';
            fireGaGameScreen('submit_game', tempGameScore, 'results_score');
          }
          setCongrate(true);
          setLoader(false);
        }
        setLoader(false);
        clearLocalStorage(`tilsudoku:${gameId}`);
        clearPlayAgain(gameId);
        // setSubmitCallPending(false);
        return false;
      })
      .catch(err => {
        console.error(err);
        setFailedAPI('submit_api');
        overlayCall('errorPopUp');
        setLoader(false);
        // setSubmitCallPending(false);
      });
    return false;
  };
  // const startTimer = () => {
  //   if (timerRef.current) clearInterval(timerRef.current);
  //   timerRef.current = setInterval(() => {
  //     setTimer(prevTimer => prevTimer + 1);
  //   }, 1000);
  // };

  const startTimer = () => {
    if (timerRef.current) return; // Ensure no timer is already running

    timerRef.current = setInterval(() => {
      setTimer(prevTimer => {
        const newTimer = prevTimer + 1;
        if (newTimer % configSaveStateCounter === 0) {
          gameStateSaveCall();
        }
        return newTimer;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null; // Clear reference to the interval
    }
  };

  const playTimer = () => {
    if (isPausedRef.current) {
      startTimer();
      isPausedRef.current = false;
    }
  };

  const pauseTimer = () => {
    if (!isPausedRef.current) {
      stopTimer();
      isPausedRef.current = true;
    }
  };

  const howtoPlaycheck = type => {
    try {
      if (typeof localStorage !== 'undefined') {
        const storedValue = localStorage.getItem('toigames');
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        const howtoplaySudoku = parsedValue ? parsedValue.howtoplaySudoku : '';
        if (!howtoplaySudoku) {
          setPopUpType(type);
          pauseTimer();
          overlayCall('howToPlaySudoku');
        }
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  // const playAgain = () => {
  //   if (typeof localStorage !== 'undefined') {
  //     let toigames = localStorage.getItem('toigames');
  //     toigames = toigames ? JSON.parse(toigames) : {};
  //     if (!toigames.playagain || !toigames.playagain.includes(gameId)) {
  //       toigames.playagain = toigames.playagain
  //         ? `${toigames},${gameId}`
  //         : gameId;
  //       localStorage.setItem('toigames', JSON.stringify(toigames));
  //     }
  //     setPlayAgainCheck(true);
  //     setAlreadyPlayed(false);
  //     setCongrate(false);
  //     getGameJsonCall();
  //     setIsSubmitted(false);
  //     setFocusedCell({ row: null, column: null });
  //     setTimer(0);
  //     setStatus('playing');
  //     setRevealedCells([]);
  //     setPenaltyCount(0);
  //     setTotalPenaltyTime(0);
  //     setPencilBoard(initialPencilBoard);
  //     setPenaltyMessage(null);
  //     setPenaltyMessage(`+ 1 Sec`);
  //     setSubmitCallPending(true);
  //     startTimer();
  //     setLoader(false);
  //   }
  // };

  // const calculatePenalty = currentPenaltyCount => {
  //   const newPenaltyCount = currentPenaltyCount + 1;
  //   const penaltyTime = 1 + (newPenaltyCount - 1) * 5;
  //   return penaltyTime;
  // };

  const gameStateFetchCall = () => {
    if (
      typeof props.loadSudokuStateFetch === 'function' &&
      userData &&
      userData.isLoggedIn &&
      todaysGame &&
      !playAgainCheck
    ) {
      const params = {
        gameId,
        gameType,
        grxId,
        ssoId,
      };
      props.loadSudokuStateFetch(params);
    }
    getStatusCall();
  };

  useEffect(() => {
    howtoPlaycheck('howToPlaySudoku');
    //getStatusCall();
    // Only call gameStateFetchCall if we're not viewing solution data
    if (!gameSolutionData || !viewSolution) {
      gameStateFetchCall();
    }
    //const penaltyRevelDisplay = calculatePenalty(penaltyCount);
    const penaltyRevelDisplay = configPenalty;
    if (window) {
      window.penaltyRevelDisplay = penaltyRevelDisplay;
    }
    setPenaltyMessage(`+ ${penaltyRevelDisplay} Sec`);
  }, []);

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData && userData.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
        }
      }
    },
    [userData, hasSynced],
  );

  useEffect(
    () => {
      const filledCells = [];
      if (puzzle && puzzle.length > 0) {
        puzzle.forEach((row, rowIndex) => {
          row.forEach((cell, colIndex) => {
            if (cell !== 0) {
              filledCells.push({ row: rowIndex, column: colIndex });
            }
          });
        });
        setInitialFilledCells(filledCells);
      }
    },
    [puzzle],
  );

  const checkIfBoardIsCorrect = boardData => {
    if (
      !solution ||
      !boardData ||
      !Array.isArray(solution) ||
      !Array.isArray(boardData) ||
      solution.length === 0 ||
      boardData.length === 0
    ) {
      return false;
    }
    for (let row = 0; row < 9; row += 1) {
      for (let col = 0; col < 9; col += 1) {
        if (boardData[row][col] !== solution[row][col]) {
          return false;
        }
      }
    }
    return true;
  };

  // Helper function to capture user's game state and update refs
  const captureUserStateAndUpdateRefs = () => {
    const userBoardState = board.map(row => [...row]);
    const userPencilBoardState = pencilBoard.map(row => [...row]);
    const userRevealedCellsState = [...revealedCells];
    const userLastFocussedCellState = { ...lastFocussedCell };
    const userTimerState = timer;
    const userTotalPenaltyTimeState = totalPenaltyTime;

    // Update all refs with the user's actual state
    boardRef.current = userBoardState;
    pencilBoardRef.current = userPencilBoardState;
    revealedCellsRef.current = userRevealedCellsState;
    lastFocussedCellRef.current = userLastFocussedCellState;
    timerRef.current = userTimerState;
    totalPenaltyTimeRef.current = userTotalPenaltyTimeState;

    return {
      userBoardState,
      userPencilBoardState,
      userRevealedCellsState,
      userLastFocussedCellState,
      userTimerState,
      userTotalPenaltyTimeState,
    };
  };

  const simmerSubmit = () => {
    setIsShimmering(true);
    stopTimer();
    setTimeout(() => {
      // Capture user's actual game state and update refs
      const {
        userTimerState,
        userTotalPenaltyTimeState,
      } = captureUserStateAndUpdateRefs();
      setIsSubmitted(true);
      setStatus('submitted');
      clearLocalStorage(`tilsudoku:${gameId}`);
      stopTimer();
      setIsShimmering(false);

      // Call Submit API
      gameSubmitCall(userTimerState, userTotalPenaltyTimeState);
    }, 2000);
  };

  const checkIfBoardIsFilled = boardData => {
    const isFilled = boardData.flat().every(cell => cell !== 0);
    if (isFilled) {
      const isCorrect = checkIfBoardIsCorrect(boardData);
      if (isCorrect && !isSubmitted) {
        //submitConfirmation();
        //---- simmer effect need to be added here ----//
        if (!showCongrate) {
          simmerSubmit();
        }
      } else {
        setIsAllCellFull(true);
      }
    } else {
      setIsAllCellFull(false);
    }
  };

  const findNextEmptyCell = (tempboard, startRow, startCol) => {
    for (let row = startRow; row < 9; row += 1) {
      for (
        let column = row === startRow ? startCol : 0;
        column < 9;
        column += 1
      ) {
        if (
          tempboard &&
          Array.isArray(tempboard) &&
          tempboard.length > 0 &&
          (tempboard[row][column] === '' || tempboard[row][column] === 0)
        ) {
          return { row, column };
        }
      }
    }
    return { row: 0, column: 0 };
  };

  const createSudokuFromState = () => {
    try {
      //if (todaysGame) {
      let stateDataLocal = '';
      if (
        stateData === 'empty' ||
        (!stateData ||
          !stateData.stateSudoku ||
          stateData.stateSudoku.gameId !== gameId)
      ) {
        const savedStateFinal = localStorage.getItem(`tilsudoku:${gameId}`);
        stateDataLocal = JSON.parse(savedStateFinal);
      } else if (stateData && stateData.stateSudoku) {
        stateDataLocal = stateData?.stateSudoku;
        stateDataLocal.revealedCells = stateDataLocal?.penaltyPairs || [];
        stateDataLocal.totalPenaltyTime =
          (stateDataLocal?.penaltyTimeInMillis || 0) / 1000;
        stateDataLocal.timer =
          (stateDataLocal?.completionTimeInMillis || 0) / 1000;
        localStorage.setItem(
          `tilsudoku:${gameId}`,
          JSON.stringify({
            board: stateDataLocal.board,
            timer: stateDataLocal.timer,
            revealedCells: stateDataLocal.revealedCells,
            //penaltyCount,
            totalPenaltyTime: stateDataLocal.totalPenaltyTime,
            pencilBoard: stateDataLocal.pencilBoard,
            isAutoSuggestActive: stateDataLocal.isAutoSuggestActive,
            lastFocussedCell:
              stateDataLocal && stateDataLocal.lastFocussedCell
                ? stateDataLocal.lastFocussedCell
                : { row: 0, column: 0 },
          }),
        );
      }
      if (stateDataLocal) {
        //overlayCall('pausegamepopup');
        setBoard(stateDataLocal.board);
        setTimer(stateDataLocal.timer);
        setRevealedCells(stateDataLocal.revealedCells);
        //setPenaltyCount(stateDataLocal.penaltyCount || 0);
        setTotalPenaltyTime(stateDataLocal.totalPenaltyTime || 0);
        setPencilBoard(stateDataLocal.pencilBoard);
        setIsAutoSuggestActive(stateDataLocal.isAutoSuggestActive);
        // const penaltyRevelDisplay = calculatePenalty(
        //   stateDataLocal.penaltyCount || 0,
        // );
        const penaltyRevelDisplay = configPenalty;
        if (window) {
          window.penaltyRevelDisplay = penaltyRevelDisplay;
        }
        setPenaltyMessage(`+ ${penaltyRevelDisplay} Sec`);
        //pauseTimer();
        const lf =
          stateDataLocal && stateDataLocal.lastFocussedCell
            ? stateDataLocal.lastFocussedCell
            : { row: 0, column: 0 };
        setFocusedCell(lf);
        checkIfBoardIsFilled(stateDataLocal.board);
      } else {
        const intialFocus = findNextEmptyCell(board, 0, 0);
        setFocusedCell(intialFocus);
      }
      // } else {
      //   if (typeof localStorage !== 'undefined') {
      //     localStorage.removeItem(`tilsudoku:${gameId}`);
      //   }
      //   setPlayAgainCheck(true);
      //   setAlreadyPlayed(false);
      //   setCongrate(false);
      //   getGameJsonCall();
      //   setIsSubmitted(false);
      //   //setFocusedCell({ row: 0, column: 0 });
      //   setTimer(0);
      //   setStatus('playing');
      //   setRevealedCells([]);
      //   setPenaltyCount(0);
      //   setTotalPenaltyTime(0);
      //   //setPenaltyMessage(null);
      //   const penaltyRevelDisplay = calculatePenalty(0);
      //   if (window) {
      //     window.penaltyRevelDisplay = penaltyRevelDisplay;
      //   }
      //   setPenaltyMessage(`+ ${penaltyRevelDisplay} Sec`);
      //   setSubmitCallPending(true);
      //   startTimer();
      //   setLoader(false);
      // }
    } catch (e) {
      console.log('game error>>', e);
      setFailedAPI('sudoku_state_creation_from_state');
      overlayCall('errorPopUp');
    }
  };

  const createSudokuFromSolutionData = () => {
    try {
      if (gameSolutionData && gameSolutionData.stateSudoku && viewSolution) {
        const solutionData = gameSolutionData.stateSudoku;
        setBoard(solutionData.board || []);
        setSolution(solutionData.board || []);
        setPencilBoard(solutionData.pencilBoard || []);
        setLoader(false);

        setStatus('submitted');
        setIsSubmitted(true);

        // Fetch the original puzzle and solution to show the solved state
        const getOriginalPuzzleAndSolution = async () => {
          try {
            const url = `${jsonUrl}`;
            const data = await makeRequest.get(url, {}, 'skipfeedengine');
            const puzzleData = data?.data?.puzzle;
            const completeSolutionData = data?.data?.solution;

            if (
              puzzleData &&
              puzzleData.length > 0 &&
              completeSolutionData &&
              completeSolutionData.length > 0
            ) {
              const initiallyFilledCells = [];
              const userIncorrectCells = [];

              setBoard(completeSolutionData.map(row => [...row]));
              setSolution(completeSolutionData.map(row => [...row]));
              puzzleData.forEach((row, rowIndex) => {
                row.forEach((cell, colIndex) => {
                  if (cell !== 0) {
                    initiallyFilledCells.push({
                      row: rowIndex,
                      column: colIndex,
                    });
                  } else {
                    const userInput = solutionData.board[rowIndex][colIndex];
                    const correctSolution =
                      completeSolutionData[rowIndex][colIndex];

                    if (userInput !== 0 && userInput !== correctSolution) {
                      userIncorrectCells.push({
                        row: rowIndex,
                        column: colIndex,
                      });
                    } else if (userInput === 0) {
                      userIncorrectCells.push({
                        row: rowIndex,
                        column: colIndex,
                      });
                    }
                  }
                });
              });

              setInitialFilledCells(initiallyFilledCells);
              setRevealedCells([
                ...(solutionData.penaltyPairs || []),
                ...userIncorrectCells,
              ]);
            }
          } catch (fetchError) {
            console.log('Error fetching original puzzle:', fetchError);
            const initiallyFilledCells = [];
            const revealedCellsForSolution = [];

            if (solutionData.board && solutionData.board.length > 0) {
              solutionData.board.forEach((row, rowIndex) => {
                row.forEach((cell, colIndex) => {
                  if (cell !== 0) {
                    initiallyFilledCells.push({
                      row: rowIndex,
                      column: colIndex,
                    });
                  } else {
                    // Empty cells should show solution with green background
                    revealedCellsForSolution.push({
                      row: rowIndex,
                      column: colIndex,
                    });
                  }
                });
              });
            }
            setInitialFilledCells(initiallyFilledCells);
            setRevealedCells([
              ...(solutionData.penaltyPairs || []),
              ...revealedCellsForSolution,
            ]);
          }
        };

        getOriginalPuzzleAndSolution();
        boardRef.current = solutionData.board;
        pencilBoardRef.current = solutionData.pencilBoard || [];
      }
    } catch (e) {
      console.log('Error creating Sudoku from solution data:', e);
      overlayCall('errorPopUp');
    }
  };

  useEffect(
    () => {
      if (gameSolutionData && viewSolution) {
        createSudokuFromSolutionData();
      }
    },
    [gameSolutionData, viewSolution],
  );

  useEffect(
    () => {
      try {
        if (
          timer !== 0 &&
          board.length > 0 &&
          !isSubmitted &&
          !alreadyPlayed &&
          typeof window !== 'undefined'
        ) {
          localStorage.setItem(
            `tilsudoku:${gameId}`,
            JSON.stringify({
              board,
              timer,
              revealedCells,
              //penaltyCount,
              totalPenaltyTime,
              pencilBoard,
              isAutoSuggestActive,
              lastFocussedCell,
            }),
          );
        }
        if (lastFocussedCell.row === 0 && lastFocussedCell.column === 0) {
          const savedStateFinal = localStorage.getItem(`tilsudoku:${gameId}`);
          if (!savedStateFinal) {
            const intialFocus = findNextEmptyCell(board, 0, 0);
            if (!showCongrate) {
              setFocusedCell(intialFocus);
            }
          }
        }
        // const activeElement = document.getElementById('active');
        // if (activeElement) {
        //   const inputElement = activeElement.querySelector('input');
        //   if (inputElement) {
        //     inputElement.focus();
        //   }
        // }
        boardRef.current = board || boardRef.current;
        revealedCellsRef.current = revealedCells || revealedCellsRef.current;
        totalPenaltyTimeRef.current =
          totalPenaltyTime || totalPenaltyTimeRef.current;
        pencilBoardRef.current = pencilBoard || pencilBoardRef.current;
        lastFocussedCellRef.current =
          lastFocussedCell || lastFocussedCellRef.current;
        timerRef.current = timer || timerRef.current;
      } catch (e) {
        console.log('game error>>', e);
        setFailedAPI('sudoku_state_creation');
        overlayCall('errorPopUp');
      }
    },
    [
      board,
      timer,
      revealedCells,
      //penaltyCount,
      totalPenaltyTime,
      pencilBoard,
      isAutoSuggestActive,
      lastFocussedCell,
    ],
  );

  useEffect(
    () => {
      if (typeof window !== 'undefined') {
        createSudokuFromState(true);
      }
    },
    [stateData],
  );

  // useEffect(
  //   () => {
  //     if (isSubmitted && submitCallPending) {
  //       gameSubmitCall(timer, totalPenaltyTime);
  //     }
  //   },
  //   [isSubmitted, timer, totalPenaltyTime],
  // );

  useEffect(() => {
    const handleBeforeUnload = event => {
      event.preventDefault();
      gameStateSaveCall();
      event.returnValue = ''; // Required for Chrome
      return ''; // Required for Firefox
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleChange = (key, rowIndex, colIndex) => {
    const newNormalBoard = [...board];
    const newPencilBoard = [...pencilBoard];
    const value = parseInt(key, 10);

    if (!isNaN(value)) {
      newNormalBoard[rowIndex][colIndex] = value;
    } else if (key === 'Backspace' || key === 'Delete' || key === 'X') {
      if (
        newNormalBoard[rowIndex][colIndex] &&
        newNormalBoard[rowIndex][colIndex] !== 0
      ) {
        newNormalBoard[rowIndex][colIndex] = 0;
      } else {
        newPencilBoard[rowIndex][colIndex] = [];
        setBoard(newPencilBoard);
      }
    }
    checkIfBoardIsFilled(newNormalBoard);
    setBoard(newNormalBoard);
  };

  const handleFocus = (row, column) => {
    setFocusedCell({ row, column });
  };

  const handlePencilInput = (rowIndex, colIndex, key) => {
    if (!isPencilMode) return;
    const newPencilBoard = [...pencilBoard];
    const newNormalBoard = [...board];
    let currentCell = newPencilBoard[rowIndex][colIndex];
    if (!Array.isArray(currentCell)) {
      currentCell = [];
    }

    if (key === 'Backspace' || key === 'Delete' || key === 'X') {
      if (
        newNormalBoard[rowIndex][colIndex] &&
        newNormalBoard[rowIndex][colIndex] !== 0
      ) {
        newNormalBoard[rowIndex][colIndex] = 0;
        setBoard(newNormalBoard);
      } else {
        newPencilBoard[rowIndex][colIndex] = [];
      }
    } else {
      const number = parseInt(key, 10);
      if (!isNaN(number)) {
        if (
          newNormalBoard[rowIndex][colIndex] &&
          newNormalBoard[rowIndex][colIndex] !== 0
        ) {
          newNormalBoard[rowIndex][colIndex] = 0;
          setBoard(newNormalBoard);
        }
        if (currentCell.includes(number)) {
          newPencilBoard[rowIndex][colIndex] = currentCell.filter(
            n => n !== number,
          );
        } else {
          newPencilBoard[rowIndex][colIndex] = [...currentCell, number].sort(
            (a, b) => a - b,
          );
        }
      }
    }

    setPencilBoard(newPencilBoard);
  };

  const handleNumberClick = number => {
    const { row, column } = lastFocussedCell;
    if (row !== null && column !== null) {
      if (isPencilMode) {
        handlePencilInput(row, column, number);
      } else {
        handleChange(number, row, column);
      }
    }
  };
  // Helper function to calculate possible values
  const getPossibleValues = (tempboard, row, col) => {
    const possible = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9]);

    for (let i = 0; i < 9; i++) {
      possible.delete(tempboard[row][i]);
      possible.delete(tempboard[i][col]);
    }

    const boxRow = Math.floor(row / 3) * 3;
    const boxCol = Math.floor(col / 3) * 3;

    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        possible.delete(tempboard[boxRow + i][boxCol + j]);
      }
    }

    return [...possible];
  };

  // Function to check if user has seen tooltip before
  const hasSeenTooltipBefore = type => {
    try {
      const storedValue = localStorage.getItem('toigames');
      const parsedValue = storedValue ? JSON.parse(storedValue) : {};
      return parsedValue[type] || false;
    } catch (error) {
      console.error('Error parsing JSON from localStorage:', error);
      return false;
    }
  };

  // Function to mark tooltip as seen
  const setTooltipSeen = type => {
    try {
      const storedValue = localStorage.getItem('toigames');
      const parsedValue = storedValue ? JSON.parse(storedValue) : {};

      parsedValue[type] = true; // Mark as seen
      localStorage.setItem('toigames', JSON.stringify(parsedValue));
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  };
  // Function to update tooltip text
  const updateTooltip = (pencilMode, autoCheck) => {
    let tooltipMessage = '';
    let shouldShowTooltip = false;

    if (pencilMode && !hasSeenTooltipBefore('pencilMode')) {
      tooltipMessage = 'Pencil-mode ON | Auto-check OFF';
      setTooltipSeen('pencilMode'); // Mark Pencil Mode tooltip as seen
      shouldShowTooltip = true;
    } else if (autoCheck && !hasSeenTooltipBefore('autoCheck')) {
      tooltipMessage = 'Auto-check ON | Pencil-mode OFF';
      setTooltipSeen('autoCheck'); // Mark Auto Check tooltip as seen
      shouldShowTooltip = true;
    }

    if (shouldShowTooltip) {
      setTooltipText(tooltipMessage);
      setShowTooltip(true);
    }
  };

  // Below code will clear the tooltip after 3 seconds
  useEffect(
    () => {
      if (showTooltip) {
        const newtimer = setTimeout(() => {
          setShowTooltip(false);
        }, 3500);

        return () => clearTimeout(newtimer);
      }
    },
    [showTooltip],
  );

  // Function to enable Pencil Mode
  const togglePencilMode = () => {
    setIsPencilMode(prev => {
      const newPencilMode = !prev;
      setIsAutoSuggestActive(false);
      if (!(newPencilMode && !isAutoSuggestActive)) {
        updateTooltip(newPencilMode, false);
      }
      const gaData = {
        event: 'user_click_games',
        type: 'pencil_mode',
        label: newPencilMode ? 'on' : 'off',
        page_template: 'gameplay',
        section: 'games',
        subsection: 'sudoku',
        browsing_platform: isMobile ? 'mweb' : 'web',
        game_id: gameId,
        level: levelData?.level?.toLowerCase(),
        game_of_the_day: window.location.href.toLowerCase().includes('/today'),
        login_status: !!ssoId,
        user_grx_id: grxId,
      };
      if (ssoId) {
        gaData.sso_id = ssoId;
      }
      analyticsWrapper('ga4', gaData);
      analyticsWrapper('grx', 'track', 'user_click_games', gaData);
      return newPencilMode;
    });
  };

  // Tooltip Component
  const Tooltip = ({ text, visible }) => (
    <>
      {showTooltip && (
        <div className={`${s.toaster} ${visible ? s.show : s.hide}`}>
          {text}
        </div>
      )}
    </>
  );

  // Function to enable Auto Check Mode
  const handleAutoCheckClick = () => {
    setIsAutoSuggestActive(prev => {
      const newAutoCheck = !prev;
      setIsPencilMode(false);
      if (!(newAutoCheck && !isPencilMode)) {
        updateTooltip(false, newAutoCheck);
      }
      const gaData = {
        event: 'user_click_games',
        type: 'auto_check',
        label: newAutoCheck ? 'on' : 'off',
        page_template: 'gameplay',
        section: 'games',
        subsection: 'sudoku',
        browsing_platform: isMobile ? 'mweb' : 'web',
        game_id: gameId,
        level: levelData?.level?.toLowerCase(),
        game_of_the_day: window.location.href.toLowerCase().includes('/today'),
        login_status: !!ssoId,
        user_grx_id: grxId,
      };
      if (ssoId) {
        gaData.sso_id = ssoId;
      }
      analyticsWrapper('ga4', gaData);
      analyticsWrapper('grx', 'track', 'user_click_games', gaData);
      return newAutoCheck;
    });
  };

  const renderBoard = () => (
    <table className={s.sudokuBoard}>
      <tbody>
        {board.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, colIndex) => {
              const isInitiallyFilled = initialFilledCells.some(
                filledCell =>
                  filledCell.row === rowIndex && filledCell.column === colIndex,
              );
              const isRevealed = revealedCells.some(
                revealedCell =>
                  revealedCell.row === rowIndex &&
                  revealedCell.column === colIndex,
              );
              const isFocused =
                lastFocussedCell.row === rowIndex &&
                lastFocussedCell.column === colIndex;

              const pencilCell = isAutoSuggestActive
                ? getPossibleValues(board, rowIndex, colIndex)
                : pencilBoardRef.current[rowIndex][colIndex];
              const normalCell = board[rowIndex][colIndex];

              let cellClass = '';
              let id = '';
              if (isRevealed) {
                cellClass = s.revealed;
              } else if (isFocused) {
                cellClass = s.sudokuCellFocused;
                id = 'active';
              }
              return (
                <td
                  key={colIndex}
                  className={`${
                    isInitiallyFilled ? s.filled : ''
                  } ${cellClass}`}
                  id={id}
                >
                  {isInitiallyFilled || isRevealed || status === 'submitted' ? (
                    <div className={s.sudokuCell}>{normalCell}</div>
                  ) : (
                    <>
                      <input
                        type="text"
                        value={normalCell === 0 ? '' : normalCell}
                        onFocus={() => handleFocus(rowIndex, colIndex)}
                        onKeyDown={e => {
                          if (isPencilMode) {
                            handlePencilInput(rowIndex, colIndex, e.key);
                          } else {
                            handleChange(e.key, rowIndex, colIndex);
                          }
                        }}
                        maxLength="1"
                        className={s.sudokuInput}
                        readOnly={isMobile}
                      />
                      {Array.isArray(pencilCell) && (
                        <pre
                          style={{
                            display: normalCell === 0 ? 'block' : 'none',
                          }}
                          className={s.sudokuPre}
                        >
                          {Array.from({ length: 9 }, (_, i) => i + 1)
                            .map(num => (pencilCell.includes(num) ? num : ' '))
                            .reduce((acc, num, idx) => {
                              const newline = (idx + 1) % 3 === 0 ? '\n' : ' ';
                              return acc + num + newline;
                            }, '')}
                        </pre>
                      )}
                    </>
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );

  const revealCellFunction = check => {
    if (check && typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      toigames.revealCellPopUpSudoku = true;
      localStorage.setItem('toigames', JSON.stringify(toigames));
    }

    const { row, column } = lastFocussedCell;
    if (row !== null && column !== null) {
      const isAlreadyRevealed = revealedCells.some(
        revealedCell =>
          revealedCell.row === row && revealedCell.column === column,
      );

      if (!isAlreadyRevealed) {
        const newBoard = board.map((r, rowIndex) =>
          r.map(
            (cell, colIndex) =>
              rowIndex === row && colIndex === column
                ? solution[row][column]
                : cell,
          ),
        );
        setBoard(newBoard);
        checkIfBoardIsFilled(newBoard);
        setRevealedCells([...revealedCells, { row, column }]);
        setFocusedCell({ row: null, column: null });

        if (board[row][column] !== solution[row][column]) {
          //const newPenaltyCount = penaltyCount + 1;
          //const penaltyTime = 1 + (newPenaltyCount - 1) * 5;
          const penaltyTime = configPenalty;
          //setPenaltyCount(newPenaltyCount);
          setTotalPenaltyTime(totalPenaltyTime + penaltyTime);
          setTimer(prev => prev + penaltyTime);
          setPenaltyMessage(`+ ${penaltyTime} Sec`);
          if (penaltySpanRef.current) {
            penaltySpanRef.current.style.opacity = '1';
          }
          setTimeout(() => {
            //setPenaltyMessage(null);
            if (penaltySpanRef.current) {
              penaltySpanRef.current.style.opacity = '.5';
            }
            //const penaltyRevelDisplay = calculatePenalty(newPenaltyCount);
            const penaltyRevelDisplay = configPenalty;
            if (window) {
              window.penaltyRevelDisplay = penaltyRevelDisplay;
            }
            setPenaltyMessage(`+ ${penaltyRevelDisplay} Sec`);
          }, 2000);
        }
      }
    }
    if (isMobile) setMenuVisible(false);
  };

  const revealCell = () => {
    overlayCall('revealCellSudoku');
    const gaData = {
      event: 'user_shown_games',
      type: 'character_reveal',
      category: 'character_reveal_popup',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'sudoku',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  useEffect(
    () => {
      if (status === 'playing' && !isPausedRef.current) {
        startTimer();
      } else {
        stopTimer();
      }

      return () => stopTimer();
    },
    [status, isPausedRef.current],
  );

  const resetBoard = check => {
    if (check && typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      toigames.resetPopUpSudoku = true;
      localStorage.setItem('toigames', JSON.stringify(toigames));
    }
    setBoard(puzzle.map(row => [...row]));
    setPencilBoard(initialPencilBoard);
    setStatus('playing');
    setRevealedCells([]);
    if (isMobile) setMenuVisible(false);
    startTimer();
  };

  const resetBoardConfirmation = () => {
    overlayCall('resetSudoku');
  };

  const calculateRevealAllPenalty = () => {
    // let newPenaltyCount = penaltyCount;
    let newPenaltyTime = totalPenaltyTime;
    board.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        const isCorrect = cell === solution[rowIndex][colIndex];
        const isAlreadyRevealed = revealedCells.some(
          revealedCell =>
            revealedCell.row === rowIndex && revealedCell.column === colIndex,
        );

        if (!isCorrect && !isAlreadyRevealed) {
          //newPenaltyCount += 1;

          //const penaltyTime = 1 + (newPenaltyCount - 1) * 5;
          const penaltyTime = configPenalty;
          newPenaltyTime += penaltyTime;
        }
      });
    });
    const penaltybythismove = newPenaltyTime - totalPenaltyTime;
    return penaltybythismove;
  };

  const revealAll = (isSubmitCase = false) => {
    //let newPenaltyCount = penaltyCount;
    let newPenaltyTime = totalPenaltyTime;

    const newBoard = board.map((row, rowIndex) =>
      row.map((cell, colIndex) => {
        const isCorrect = cell === solution[rowIndex][colIndex];
        const isAlreadyRevealed = revealedCells.some(
          revealedCell =>
            revealedCell.row === rowIndex && revealedCell.column === colIndex,
        );

        if (!isCorrect && !isAlreadyRevealed) {
          //newPenaltyCount += 1;
          setRevealedCells(prev => [
            ...prev,
            { row: rowIndex, column: colIndex },
          ]);

          // Calculate the penalty time for this cell
          //const penaltyTime = 1 + (newPenaltyCount - 1) * 5;
          const penaltyTime = configPenalty;
          newPenaltyTime += penaltyTime;
        }

        return solution[rowIndex][colIndex];
      }),
    );

    // Set the accumulated penalty time and count
    setTimer(prev => prev + (newPenaltyTime - totalPenaltyTime));
    //setPenaltyCount(newPenaltyCount);
    setTotalPenaltyTime(newPenaltyTime);
    setBoard(newBoard);
    setStatus('playing');
    if (!isSubmitCase) {
      checkIfBoardIsFilled(newBoard);
    }
    setFocusedCell({ row: null, column: null });
    if (isMobile) setMenuVisible(false);
  };

  const revealAllConfirmation = () => {
    if (window) {
      window.calculatedRevealAllPenalty = calculateRevealAllPenalty();
    }
    overlayCall('revealPuzzleSudoku');
    const gaData = {
      event: 'user_shown_games',
      type: 'game_reveal',
      category: 'game_reveal_popup',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'sudoku',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const submitConfirmation = () => {
    overlayCall('submitSudoku');
    const gaData = {
      event: 'user_shown_games',
      type: 'submit',
      category: 'submit_popup',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'sudoku',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const submit = () => {
    stopTimer();
    // Check Penanlty
    const revealAllPenalty = calculateRevealAllPenalty();
    const totalPenaltyWithRevealAll = totalPenaltyTime + revealAllPenalty;
    // Capture User Game State
    const { userTimerState } = captureUserStateAndUpdateRefs();

    revealAll(true);
    setIsSubmitted(true);
    setStatus('submitted');
    //isSubmittedRef.current = true;
    clearLocalStorage(`tilsudoku:${gameId}`);
    stopTimer();

    // Calling Submit API
    gameSubmitCall(userTimerState, totalPenaltyWithRevealAll);
  };

  const formatTime = time => {
    const totalTime = time;
    const hours = String(Math.floor(totalTime / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((totalTime % 3600) / 60)).padStart(
      2,
      '0',
    );
    const seconds = String(totalTime % 60).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const howtoPlay = (isHelpBar = '') => {
    overlayCall('howToPlaySudoku');
    setMenuVisible(false);
    const gaData = {
      event: 'user_shown_games',
      type: 'how_to_play',
      label: isHelpBar ? 'help_bar' : 'start_game',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'sudoku',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const gameOverlayCallback = () => {
    setShowOverlay(false);
  };

  const callonContinue = (type, check = undefined) => {
    switch (type) {
      case 'revealCellSudoku':
        revealCellFunction(check);
        break;
      case 'resetSudoku':
        resetBoard(check);
        break;
      case 'revealPuzzleSudoku':
        revealAll();
        break;
      case 'submitConfirmation': {
        const gaData = {
          event: 'user_click_games',
          type: 'submit_game',
          label: 'manual_submit',
          category: 'submit_popup',
          page_template: 'gameplay',
          section: 'games',
          subsection: 'sudoku',
          browsing_platform: isMobile ? 'mweb' : 'web',
          game_id: gameId,
          level: levelData?.level?.toLowerCase(),
          game_of_the_day: window.location.href
            .toLowerCase()
            .includes('/today'),
          login_status: !!ssoId,
          user_grx_id: grxId,
        };
        if (ssoId) {
          gaData.sso_id = ssoId;
        }
        analyticsWrapper('ga4', gaData);
        analyticsWrapper('grx', 'track', 'user_click_games', gaData);
        submit();
        break;
      }
      case 'pausegamepopup':
        playTimer();
        break;
      case 'howToPlaySudoku':
        playTimer();
        break;
      default:
        break;
    }
  };
  const resetState = () => {
    setTimer(0);
    setBoard([]);
    clearInterval(timerRef.current); // Clear any running timers
    stateData = undefined;
    gameId = undefined;
  };

  const hardPause = () => {
    gameStateSaveCall();
    resetState();
    if (typeof handleGameCallback === 'function') {
      handleGameCallback();
    }
    fireGa4andGrx(
      'pause',
      'user_click_games',
      'gameplay',
      'sudoku',
      isMobile,
      gameId,
      '',
      levelData?.level?.toLowerCase(),
    );
  };

  const fireGaForRevelCell = gaCategory => {
    const gaData = {
      event: 'user_click_games',
      type: 'character_reveal',
      category: gaCategory || '',
      page_template: 'gameplay',
      section: 'games',
      subsection: 'sudoku',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: levelData?.level?.toLowerCase(),
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_click_games', gaData);
  };

  const manageTimer = () => {
    try {
      if (typeof localStorage !== 'undefined') {
        const storedValue = localStorage.getItem('toigames');
        const parsedValue = storedValue ? JSON.parse(storedValue) : '';
        const howtoplaySudoku = parsedValue ? parsedValue.howtoplaySudoku : '';
        if (howtoplaySudoku) {
          if (document.visibilityState === 'hidden') {
            if (!isSubmitted) {
              hardPause();
              pauseTimer();
            }
          } else if (document.visibilityState === 'visible') {
            if (!isSubmitted) {
              playTimer();
            }
          }
        }
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  useEffect(() => {
    // Add visibility change event listener
    document.addEventListener('visibilitychange', manageTimer);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener('visibilitychange', manageTimer);
      stopTimer(); // Ensure timer is stopped when component unmounts
    };
  }, []);

  // const renderShareFeedbank = () => (
  //   <div className={s.shareFeedback}>
  //     <strong>Share Your Feeback</strong>
  //     <Link
  //       target="_blank"
  //       className={s.btnPrimary}
  //       data-newga=""
  //       to="https://docs.google.com/forms/d/e/1FAIpQLSd5hAk46tH9cOSN6WwbWiVXyr9LYCoyKPVkHpZdZbfi4Y3JCQ/viewform"
  //       title="feedback"
  //     >
  //       Submit Here
  //     </Link>
  //   </div>
  // );

  let breadCrumbData;
  if (isToday) {
    breadCrumbData =
      breadcrumbs && breadcrumbs.sudokuToday ? breadcrumbs.sudokuToday : [];
  } else {
    breadCrumbData =
      breadcrumbs && breadcrumbs.sudokuPractice
        ? breadcrumbs.sudokuPractice
        : [];
  }
  return (
    <>
      <div className={s.pageWrapper}>
        {!viewSolution && (
          <>
            {breadCrumbData &&
              !isMobile && (
                <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
              )}
            {showLoader && (
              <div className={s.loaderouter}>
                <LoaderSpinner />
              </div>
            )}
            {!showCongrate && (
              <div className={s.title}>
                <h1>
                  {gamesMetaWidgetData?.metaInfo?.TemplateH1TopHeading?.value}
                </h1>
                {isMobile ? (
                  ''
                ) : (
                  <ShareButton
                    url={`${TOI_LIVE_DOMAIN}/games/sudoku/today?utm_source=social_share&utm_medium=social&utm_campaign=games`}
                    gaCat="Sudoku"
                  />
                )}
              </div>
            )}
            {showOverlay && (
              <GameOverlay
                commonTranslations={commonTranslations}
                gameSpecificTranslations={gameSpecificTranslations}
                popUpType={popUpType}
                gameOverlayCallback={gameOverlayCallback}
                callonContinue={callonContinue}
                gameType="sudoku"
                gameLevel={levelData?.level?.toLowerCase()}
                gameId={gameId}
                failedAPI={failedAPI}
              />
            )}
          </>
        )}
        {!alreadyPlayed && (
          <>
            {!viewSolution && (
              <div
                className={`${s.timeBlock} ${showCongrate ? s.disabled : ''}`}
                style={{ display: showCongrate ? 'none' : '' }}
              >
                <div className={s.left}>
                  <strong>{formatTime(timer)}</strong>
                </div>
                <div className={s.right}>
                  {isMobile && (
                    <div className={s.actionWrap}>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (!isSubmitted) {
                            hardPause();
                          }
                        }}
                      >
                        <i className={`${s.icon} ${s.pause}`} />
                      </div>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (!isSubmitted) {
                            const gaData = {
                              event: 'user_click_games',
                              type: 'how_to_play',
                              page_template: 'gameplay',
                              section: 'games',
                              subsection: 'sudoku',
                              browsing_platform: isMobile ? 'mweb' : 'web',
                              game_id: gameId,
                              level: levelData?.level?.toLowerCase(),
                              game_of_the_day: window.location.href
                                .toLowerCase()
                                .includes('/today'),
                              login_status: !!ssoId,
                              user_grx_id: grxId,
                            };
                            if (ssoId) {
                              gaData.sso_id = ssoId;
                            }
                            analyticsWrapper('ga4', gaData);
                            analyticsWrapper(
                              'grx',
                              'track',
                              'user_click_games',
                              gaData,
                            );
                            howtoPlay(true);
                          }
                        }}
                      >
                        <i className={`${s.icon} ${s.question}`} />
                      </div>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (
                            !isSubmitted &&
                            lastFocussedCell &&
                            (lastFocussedCell.row || lastFocussedCell.column)
                          ) {
                            if (typeof localStorage !== 'undefined') {
                              const storedValue = localStorage.getItem(
                                'toigames',
                              );
                              const parsedValue = storedValue
                                ? JSON.parse(storedValue)
                                : '';
                              const revealCellPopUpSudoku = parsedValue
                                ? parsedValue.revealCellPopUpSudoku
                                : '';
                              if (revealCellPopUpSudoku) {
                                revealCellFunction();
                                fireGaForRevelCell('nonpopup');
                                return false;
                              }
                            }
                            revealCell();
                            fireGaForRevelCell('popup');
                          }
                          return false;
                        }}
                        id="sudo-pulse-wrapper"
                      >
                        <i
                          className={`${s.icon} ${s.reveal} ${
                            lastFocussedCell &&
                            (lastFocussedCell.row || lastFocussedCell.column)
                              ? ''
                              : s.disabled
                          }`}
                        />
                        {penaltyMessage && (
                          <span
                            className={s.plusPoint}
                            style={{ display: 'inline', opacity: '.5' }}
                            ref={penaltySpanRef}
                          >
                            {penaltyMessage}
                          </span>
                        )}
                      </div>
                      <div className={s.circle}>
                        <i
                          className={`${s.icon} ${s.dots}`}
                          id="sudo-dots"
                          onClick={() => {
                            if (!isSubmitted) {
                              toggleMenu();
                            }
                          }}
                        />
                        {menuVisible && (
                          <ul className={s.menuList}>
                            <li
                              onClick={() => {
                                if (!isSubmitted) {
                                  if (typeof localStorage !== 'undefined') {
                                    const storedValue = localStorage.getItem(
                                      'toigames',
                                    );
                                    const parsedValue = storedValue
                                      ? JSON.parse(storedValue)
                                      : '';
                                    const revealCellPopUpSudoku = parsedValue
                                      ? parsedValue.revealCellPopUpSudoku
                                      : '';
                                    if (revealCellPopUpSudoku) {
                                      revealCellFunction();
                                      fireGaForRevelCell('popup');
                                      return false;
                                    }
                                  }
                                  revealCell();
                                  fireGaForRevelCell('nonpopup');
                                }
                                return false;
                              }}
                            >
                              <div className={s.iconWrap}>
                                <i
                                  className={`${s.icon} ${s.revealCharacter}`}
                                />
                              </div>
                              <span>Reveal Digit *</span>
                            </li>
                            <li
                              onClick={() => {
                                if (!isSubmitted) {
                                  revealAllConfirmation();
                                  //fireGa('reveal_puzzle', 'game');
                                }
                              }}
                            >
                              <div className={s.iconWrap}>
                                <i className={`${s.icon} ${s.revealPuzzle}`} />
                              </div>
                              <span>Reveal Puzzle *</span>
                            </li>
                            <li
                              onClick={() => {
                                if (!isSubmitted) {
                                  const gaData = {
                                    event: 'user_click_games',
                                    type: 'play_again',
                                    page_template: 'gameplay',
                                    section: 'games',
                                    subsection: 'sudoku',
                                    browsing_platform: isMobile
                                      ? 'mweb'
                                      : 'web',
                                    game_id: gameId,
                                    level: levelData?.level?.toLowerCase(),
                                    game_of_the_day: window.location.href
                                      .toLowerCase()
                                      .includes('/today'),
                                    login_status: !!ssoId,
                                    user_grx_id: grxId,
                                  };
                                  if (ssoId) {
                                    gaData.sso_id = ssoId;
                                  }
                                  analyticsWrapper('ga4', gaData);
                                  analyticsWrapper(
                                    'grx',
                                    'track',
                                    'user_click_games',
                                    gaData,
                                  );
                                  if (typeof localStorage !== 'undefined') {
                                    const storedValue = localStorage.getItem(
                                      'toigames',
                                    );
                                    const parsedValue = storedValue
                                      ? JSON.parse(storedValue)
                                      : '';
                                    const resetPopUpSudoku = parsedValue
                                      ? parsedValue.resetPopUpSudoku
                                      : '';
                                    if (resetPopUpSudoku) {
                                      resetBoard();
                                      return false;
                                    }
                                  }
                                  resetBoardConfirmation();
                                }
                                return false;
                              }}
                            >
                              <div className={s.iconWrap}>
                                <i className={`${s.icon} ${s.reset}`} />
                              </div>
                              <span>Reset Puzzle</span>
                            </li>
                            <li
                              onClick={() => {
                                if (!isSubmitted) {
                                  const gaData = {
                                    event: 'user_click_games',
                                    type: 'how_to_play',
                                    page_template: 'gameplay',
                                    section: 'games',
                                    subsection: 'sudoku',
                                    browsing_platform: isMobile
                                      ? 'mweb'
                                      : 'web',
                                    game_id: gameId,
                                    level: levelData?.level?.toLowerCase(),
                                    game_of_the_day: window.location.href
                                      .toLowerCase()
                                      .includes('/today'),
                                    login_status: !!ssoId,
                                    user_grx_id: grxId,
                                  };
                                  if (ssoId) {
                                    gaData.sso_id = ssoId;
                                  }
                                  analyticsWrapper('ga4', gaData);
                                  analyticsWrapper(
                                    'grx',
                                    'track',
                                    'user_click_games',
                                    gaData,
                                  );
                                }
                                howtoPlay(true);
                              }}
                            >
                              <div className={s.iconWrap}>
                                <i className={`${s.icon} ${s.question}`} />
                              </div>
                              <span>How to Play?</span>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  )}
                  {!isMobile && (
                    <div className={s.actionWrap}>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (!isSubmitted) {
                            hardPause();
                          }
                        }}
                      >
                        <i className={`${s.icon} ${s.pause}`} />
                      </div>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (
                            lastFocussedCell &&
                            lastFocussedCell.row !== null &&
                            lastFocussedCell.column !== null &&
                            !isSubmitted
                          ) {
                            if (typeof localStorage !== 'undefined') {
                              const storedValue = localStorage.getItem(
                                'toigames',
                              );
                              const parsedValue = storedValue
                                ? JSON.parse(storedValue)
                                : '';
                              const revealCellPopUpSudoku = parsedValue
                                ? parsedValue.revealCellPopUpSudoku
                                : '';
                              if (revealCellPopUpSudoku) {
                                revealCellFunction();
                                fireGaForRevelCell('popup');
                                return false;
                              }
                            }
                            revealCell();
                            fireGaForRevelCell('nonpopup');
                          }
                          return false;
                        }}
                      >
                        <i
                          className={`${s.icon} ${s.reveal} ${
                            lastFocussedCell &&
                            (lastFocussedCell.row !== null &&
                              lastFocussedCell.column !== null)
                              ? ''
                              : s.disabled
                          }`}
                        />
                        {penaltyMessage && (
                          <span
                            className={s.plusPoint}
                            style={{ display: 'inline', opacity: '.5' }}
                            ref={penaltySpanRef}
                          >
                            {penaltyMessage}
                          </span>
                        )}
                      </div>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (!isSubmitted) {
                            revealAllConfirmation();
                            //fireGa('reveal_puzzle', 'game');
                          }
                        }}
                      >
                        <i className={`${s.icon} ${s.revealPuzzle}`} />
                      </div>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (!isSubmitted) {
                            const gaData = {
                              event: 'user_click_games',
                              type: 'play_again',
                              page_template: 'gameplay',
                              section: 'games',
                              subsection: 'sudoku',
                              browsing_platform: isMobile ? 'mweb' : 'web',
                              game_id: gameId,
                              level: levelData?.level?.toLowerCase(),
                              game_of_the_day: window.location.href
                                .toLowerCase()
                                .includes('/today'),
                              login_status: !!ssoId,
                              user_grx_id: grxId,
                            };
                            if (ssoId) {
                              gaData.sso_id = ssoId;
                            }
                            analyticsWrapper('ga4', gaData);
                            analyticsWrapper(
                              'grx',
                              'track',
                              'user_click_games',
                              gaData,
                            );
                            if (typeof localStorage !== 'undefined') {
                              const storedValue = localStorage.getItem(
                                'toigames',
                              );
                              const parsedValue = storedValue
                                ? JSON.parse(storedValue)
                                : '';
                              const resetPopUpSudoku = parsedValue
                                ? parsedValue.resetPopUpSudoku
                                : '';
                              if (resetPopUpSudoku) {
                                resetBoard();
                                return false;
                              }
                            }
                            resetBoardConfirmation();
                          }
                          return false;
                        }}
                      >
                        <i className={`${s.icon} ${s.reset}`} />
                      </div>
                      <div
                        className={s.circle}
                        onClick={() => {
                          if (!isSubmitted) {
                            const gaData = {
                              event: 'user_click_games',
                              type: 'how_to_play',
                              page_template: 'gameplay',
                              section: 'games',
                              subsection: 'sudoku',
                              browsing_platform: isMobile ? 'mweb' : 'web',
                              game_id: gameId,
                              level: levelData?.level?.toLowerCase(),
                              game_of_the_day: window.location.href
                                .toLowerCase()
                                .includes('/today'),
                              login_status: !!ssoId,
                              user_grx_id: grxId,
                            };
                            if (ssoId) {
                              gaData.sso_id = ssoId;
                            }
                            analyticsWrapper('ga4', gaData);
                            analyticsWrapper(
                              'grx',
                              'track',
                              'user_click_games',
                              gaData,
                            );
                            howtoPlay(true);
                          }
                        }}
                      >
                        <i className={`${s.icon} ${s.question}`} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {((!viewSolution && !showCongrate) || viewSolution) && (
              <div className={s.sudokuWrap}>
                <div className={s.sudoku}>
                  <div
                    className={`${s.sudokuContainer} ${
                      isShimmering ? s.shimmer : ''
                    }`}
                  >
                    {renderBoard()}
                  </div>
                </div>
                {!viewSolution && (
                  <div id="sudo-controls-etc" className={s.sudokuControlsEtc}>
                    <div
                      id="sudo-controls"
                      className={`${s.sudokuControls} ${s.sudokuWideBox}`}
                    >
                      {isMobile &&
                        !isSubmitted && (
                          <AutoCheck
                            isAutoSuggestActive={isAutoSuggestActive}
                            handleAutoCheckClick={handleAutoCheckClick}
                          />
                        )}
                      <div className={s.keyToastWrap}>
                        <div className={s.sudokuKeypad}>
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 'X'].map(number => (
                            <button
                              key={number}
                              onClick={() => handleNumberClick(number)}
                              className={number === 'X' ? s.close : ''}
                            >
                              {number}
                            </button>
                          ))}
                          {!isSubmitted &&
                            !isShimmering && (
                              <>
                                <div className={s.submitPencil}>
                                  <div className={s.submitWrap}>
                                    <button
                                      id="sudo-submit"
                                      className={`${s.sudokuButtons} ${
                                        s.sudokuSubmitBtn
                                      } ${
                                        isAllCellFull
                                          ? s.sudokuSubmitBtnActive
                                          : ''
                                      }`}
                                      onClick={() => {
                                        const gaData = {
                                          event: 'user_click_games',
                                          type: 'submit',
                                          category: 'popup',
                                          page_template: 'gameplay',
                                          section: 'games',
                                          subsection: 'sudoku',
                                          browsing_platform: isMobile
                                            ? 'mweb'
                                            : 'web',
                                          game_id: gameId,
                                          level: levelData?.level?.toLowerCase(),
                                          game_of_the_day: window.location.href
                                            .toLowerCase()
                                            .includes('/today'),
                                          login_status: !!ssoId,
                                          user_grx_id: grxId,
                                        };
                                        if (ssoId) {
                                          gaData.sso_id = ssoId;
                                        }
                                        analyticsWrapper('ga4', gaData);
                                        analyticsWrapper(
                                          'grx',
                                          'track',
                                          'user_click_games',
                                          gaData,
                                        );
                                        submitConfirmation();
                                      }}
                                    >
                                      Submit
                                    </button>
                                  </div>
                                  <button
                                    // onClick={() => setIsPencilMode(!isPencilMode)}
                                    onClick={togglePencilMode}
                                    className={`${s.mode} ${
                                      isPencilMode ? s.active : ``
                                    }`}
                                  >
                                    <i className={s.pencilIcon} />
                                    {isPencilMode ? 'On' : 'Off'}
                                  </button>
                                </div>
                              </>
                            )}
                        </div>
                        {/* Tooltip */}
                        <Tooltip text={tooltipText} visible={showTooltip} />
                      </div>
                      {!isMobile &&
                        !isSubmitted && (
                          <AutoCheck
                            isAutoSuggestActive={isAutoSuggestActive}
                            handleAutoCheckClick={handleAutoCheckClick}
                            positionClass="bottom"
                          />
                        )}
                      <div
                        id="sudo-buttons-extra-row"
                        className={s.sudokuControlsRow}
                      >
                        <div className={s.gameSubmitArea}>
                          {!isSubmitted && (
                            <>
                              {/* <div className={s.submitWrap}>
                          <button
                            id="sudo-submit"
                            className={`${s.sudokuButtons} ${
                              s.sudokuSubmitBtn
                            }`}
                            onClick={submitConfirmation}
                          >
                            Submit
                          </button>
                        </div> */}
                              <div className={s.noteArea}>
                                <strong>Note:</strong>
                                <ul>
                                  <li>
                                    Revealing every character adds an
                                    incremental time penalty
                                  </li>
                                  <li>
                                    Revealing puzzle adds a cumulative
                                    incremental penalty for all the blank and
                                    incorrectly filled cells
                                  </li>
                                </ul>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
      {!viewSolution && (
        <>
          {resultData &&
            !playAgainCheck && (
              <>
                <CongratulationsNew
                  resultData={resultData}
                  gameId={gameId}
                  showCongrate={showCongrate}
                  playAgainCheck={
                    buttonClicked === 'viewResult' ? '' : playAgainCheck
                  }
                  buttonClicked={buttonClicked}
                  type="sudoku"
                  subType={levelData?.level?.toLowerCase()}
                />
                {/* <Congratulations
              resultData={resultData}
              gameId={gameId}
              showCongrate={showCongrate}
              playAgainCheck={
                buttonClicked === 'viewResult' ? '' : playAgainCheck
              }
              type="sudoku"
              subType={levelData?.level?.toLowerCase()}
            /> */}
              </>
            )}
          <div className={s.gameWrapper}>
            <div className={s.gameLeftArea}>
              {/* {(!showCongrate || playAgainCheck) && renderShareFeedbank()} */}
              {resultData &&
                playAgainCheck && (
                  <div className={s.previousGame}>
                    <h2>Previous Game</h2>
                    <div className={s.previousGameWrap}>
                      <ul>
                        <li>
                          <div className={s.left}>Your completing time is</div>
                          <div className={s.time}>
                            {msToTime(resultData.completionTimeInMillis) ||
                              'N/A'}
                          </div>
                        </li>
                        <li>
                          <div className={s.left}>
                            Penalty Time
                            <span>Due to reveal &amp; Incorrect answers*</span>
                          </div>
                          <div className={`${s.time} ${s.penaltyTime}`}>
                            {msToTime(resultData.penaltyTimeInMilliseconds) ||
                              'N/A'}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
            </div>
            {/* <div className={s.gameRightArea}>
          {(showCongrate || playAgainCheck) && (
            <>
              <LeaderBoard gameId={gameId} />
            </>
          )}
        </div> */}
          </div>
          <div className={s.gameCardAreaWrapper}>
            {showCongrate && (
              <div className={s.gameCardArea}>
                {/* {!alreadyPlayed && (
                   <div className={s.gamePoints}>
                     <ul>
                       <li>
                         Correctly filled cell
                         <div className={s.block}>1</div>
                       </li>
                       <li>
                         Incorrectly filled &amp; blank cell revealed
                         <div className={`${s.block} ${s.green}`}>1</div>
                       </li>
                     </ul>
                   </div>
                 )} */}
                <div className={s.gameWidget}>
                  {/* <div className={s.practiceCard}>
              <PracticeCard
                gameType="sudoku"
                isLargeCard={!isMobile}
                subType={levelData?.level?.toLowerCase()}
                ga4Category="congratulations"
                gameId={gameId}
                isMobile={isMobile}
                gameLevel={levelData?.level?.toLowerCase()}
              />
            </div> */}
                  <MoreOnGames
                    gameType="sudoku"
                    isMobile
                    forceLoadDataOnInit
                    isCogratulationsPage
                    cardProps={{ ga4Category: 'congratulations' }}
                    gameId={gameId}
                    gameLevel={levelData?.level?.toLowerCase()}
                    moreOnGamesTitle="Explore More Games"
                  />
                  {/* <div className={s.gameCardList}>
              <GameCardListing
                cardsIncluded={['crossword', 'mini_crossword']}
                forceLoadDataOnInit
                isCogratulationsPage
                cardProps={{ ga4Category: 'congratulations' }}
                loaderClass={
                  isMobile
                    ? 'congratulations_mobile'
                    : 'congratulations_desktop'
                }
              />
            </div> */}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};
SudokuGame.propTypes = {
  isMobile: PropTypes.bool,
  puzzleAPI: PropTypes.shape({}),
  isToday: PropTypes.bool,
};

SudokuGame.defaultProps = {
  isMobile: false,
  puzzleAPI: {},
  isToday: false,
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
  apiConfigData: _get(state, 'toigames.gamesconfig.gameCategories.sudoku', ''),
  stateData: state.toigames && state.toigames.sudokustate,
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadSudokuStateFetch: params => {
    dispatch(loadSudokuStateFetch(params));
  },
  loadSudokuStateSave: params => {
    dispatch(loadSudokuStateSave(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(SudokuGame);
